export default "__VITE_ASSET__ca7e0900__"